import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import styles from './Clan.scss'

const Clan = ({ tag, name, color, emblem, battle, nameColor, tooltipId, tooltipData, className }) => {
    const dataAttrs = tooltipId ? {
        'data-tip': tooltipData || true,
        'data-for': tooltipId,
    } : {}

    return (
        <div
            className={cx(
                styles.base, {
                    [styles.base__battle]: battle,
                },
                className)}
            {...dataAttrs}
        >
            <div className={styles.emblem}>
                <img className={styles.logo} src={emblem} />
            </div>
            <p className={styles.name} style={{ color: nameColor }}>
                <span style={{ color: color || '' }}>{`[${tag}]`}</span>{'\u0020'}
                {name}
            </p>
            <p className={styles.battle}>{battle}</p>
        </div>
    )
}

Clan.propTypes = {
    tag: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string,
    emblem: PropTypes.string.isRequired,
    battle: PropTypes.node,
    nameColor: PropTypes.string,
    tooltipId: PropTypes.string,
    tooltipData: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    className: PropTypes.string,
}

export default Clan



// WEBPACK FOOTER //
// ./components/Clan/Clan.jsx